import React, { ComponentProps } from "react";

import * as S from "./Tbody.styles";

type InfiniteScrollProps = ComponentProps<typeof S.InfiniteScroll>;
export interface Props extends Partial<Omit<InfiniteScrollProps, "onScroll">> {
  children: React.ReactNode;
  className?: string;
  height?: string;
  hasMore?: boolean;
  onScroll?: React.UIEventHandler<HTMLDivElement>;
}

const Tbody = ({
  className,
  height,
  hasMore,
  loadMore,
  onScroll,
  ...infiniteScrollProps
}: Props) => (
  <S.Layout onScroll={onScroll} height={height} className={className}>
    <S.InfiniteScroll
      loadMore={loadMore || (() => {})}
      hasMore={hasMore}
      useWindow={false}
      tabIndex={0}
      {...infiniteScrollProps}
    />
  </S.Layout>
);

export default React.memo(Tbody);
